exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-gen-quotation-payments .modal-dialog{max-width:65vw}#customer-gen-quotation-payments .table tr:nth-child(2n){background-color:var(--theme-highlight)}", ""]);

// exports
